/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { AdminDeleteVideoOptions, AdminDeleteVideoResponses } from '../../models/AdminDeleteVideo'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @description Delete a video
 * @summary Delete Video
 * {@link /admin/video/:video_id}
 */
export function adminDeleteVideo<ThrowOnError extends boolean = true>(options: Options<AdminDeleteVideoOptions, ThrowOnError>): Promise<UnwrappedResult<AdminDeleteVideoResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'DELETE', url: '/admin/video/{video_id}', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<AdminDeleteVideoResponses, ThrowOnError>>
}
